// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"1953":"97ad491f","3610":"7f88731a","6618":"97ad491f","7561":"aa1e9f8b"}[chunkId] + ".css";
};